export function subtractOnePixel(value: string): string {
  const match = value.match(/^(\d+)(px)?$/);
  if (!match) {
    throw new Error('Invalid breakpoint value format');
  }

  const num = parseInt(match[1], 10);
  return `${num - 1}px`;
}
